import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const ListError = styled(Box)`
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li:not(:first-of-type) {
        margin-inline: 0.5rem;
    }
`
